import { render, staticRenderFns } from "./CartaoJob.vue?vue&type=template&id=1ab8be90&scoped=true"
import script from "./CartaoJob.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoJob.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoJob.vue?vue&type=style&index=0&id=1ab8be90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab8be90",
  null
  
)

export default component.exports